module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"svobodnyy":"АГПЗ, АГХК"},"en":{"svobodnyy":"АГПЗ, АГХК"}}')
  delete Component.options._Ctor
}
